// extracted by mini-css-extract-plugin
export default {"comment":"comment_comment__Ksp35","message":"comment_message__xme37","buttons":"comment_buttons__rvbc+","count":"comment_count__1IB-H","delete":"comment_delete__+OeX+"};